// #2012 — Score Admin's ride view (RideEditor.jsx) offers a Simple/Detailed
// toggle for how a test's movements render. Simple (the default) shows only
// the movement text in fixed-width columns, no directive/annotation text;
// Detailed's own content is a later card (#1998-B) — for now it is today's
// unchanged rendering (directive line included, no forced column widths).
//
// Persisted in localStorage, same pattern as scribe-fe's sheetFieldOrder.js
// (#671): a namespaced key, try/catch'd get/set so a browser with storage
// disabled (private mode) degrades to the default instead of throwing. This
// is a per-device display preference, not part of the user/account record —
// it does not need to follow an admin across devices.

export const RIDE_VIEW_MODES = {
  SIMPLE: "simple",
  DETAILED: "detailed",
};

const VALID = [RIDE_VIEW_MODES.SIMPLE, RIDE_VIEW_MODES.DETAILED];

const STORAGE_KEY = "scoreadmin-fe.rideViewMode";

/** @returns {string} RIDE_VIEW_MODES.SIMPLE (default) or .DETAILED. */
export function getRideViewMode() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    // Unset, or junk written by a future/older build — fall back to the
    // spec default (AC2: Simple with no setting applied) rather than
    // handing the caller a value it can't render.
    return VALID.includes(raw) ? raw : RIDE_VIEW_MODES.SIMPLE;
  } catch {
    return RIDE_VIEW_MODES.SIMPLE;
  }
}

/** @param {string} mode - a RIDE_VIEW_MODES value; anything else is ignored. */
export function setRideViewMode(mode) {
  if (!VALID.includes(mode)) return;
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Storage unavailable (private browsing) — non-fatal; the setting just
    // won't survive the reload.
  }
}

// #2012 AC4 — the catalog's multi-line text convention uses "|" to delimit
// lines (see TestDefEditor's lineBreakHelp/newlineWarning, and #214's
// PipeText in scribe-fe's ScoringForm.jsx, which renders each segment on its
// own line). The ride view's Simple mode instead joins segments inline with
// a spaced middle dot — never a raw pipe — since Simple's whole point is a
// compact, fixed-width single line per movement. Empty segments are
// dropped; a value with no pipe (or no value) is still trimmed, not passed
// through unchanged.
export function formatSimpleMovementText(text) {
  if (!text) return "";
  return String(text)
    .split("|")
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
    .join(" · ");
}
